import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ChipTypeService } from '../../../services/rest/chip-type.service';
import { InputButtonIconType } from '../../core/button/button.utils';

@Component({
  selector: 'app-chip-type-create',
  templateUrl: './chip-type-create.component.html',
  styleUrls: ['./chip-type-create.component.scss'],
})
export class ChipTypeCreateComponent implements OnInit {
  InputButtonIconType = InputButtonIconType;
  form: FormGroup;
  error: string | null = null;

  constructor(
    private fb: FormBuilder,
    private service: ChipTypeService,
    private router: Router
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      code: ['', Validators.required],
    });
  }

  ngOnInit(): void {}

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const val = this.form.value;
    this.service.create(val).subscribe(
      () => this.router.navigate(['/chip-type']),
      (err) => (this.error = 'Fehler beim Erstellen')
    );
  }

  cancel(): void {
    this.router.navigate(['/chip-type']);
  }
}
